module.exports = __webpack_public_path__ + "static/media/Buttongrey.28f95c79.svg";